// extracted by mini-css-extract-plugin
module.exports = {"container":"_2h_gSeI","background":"_1JAvTqm","title":"_2y_lcpV","subTitle":"_4hVB-H6","callout":"_2pNugm1","games":"_23CKdTY","game":"_3JPOW5O"};